































































import {Component, Vue, Watch} from 'vue-property-decorator';
import {namespace} from 'vuex-class';

import DialogFooter from '@/components/UI/DialogFooter.vue';
import BtnDefault from '@/components/UI/BtnDefault.vue';
import DatePickerWithTime from "@/components/UI/DatePickerWithTime.vue";
import Exhibition from '@/components/beta/Workspace/Components/Exhibition.vue';

const dialog = namespace('dialog')
const forms = namespace('forms')
const workspace = namespace('workspace')

@Component({
  components: {
    BtnDefault,
    DialogFooter,
    DatePickerWithTime,
    Exhibition
  },
  name: "AddExhibitionForm"
})
export default class AddExhibitionForm extends Vue {

  @dialog.Getter('fullDialogShow') protected fullDialogShow: any
  @dialog.Mutation('SetFullDialogShow') protected SetFullDialogShow: any

  @forms.Getter('options') protected options:any

  @workspace.Getter('getCurrentShow') protected getCurrentShow: any
  @workspace.Action('getCurrentUserExhibitions') protected getCurrentUserExhibitions: any
  @workspace.Action('getCurrentCompanyExhibitions') protected getCurrentCompanyExhibitions: any
  @workspace.Action('getSearchedUserExhibitions') protected getSearchedUserExhibitions: any
  @workspace.Action('getSearchedCompanyExhibitions') protected getSearchedCompanyExhibitions: any
  @workspace.Action('addUserExhibition') protected addUserExhibition: any
  @workspace.Action('addCompanyExhibition') protected addCompanyExhibition: any

  title:string = ''
  DateTimeBegin: any = ''
  DateTimeEnd: any = ''
  loading:boolean = false
  isError:any = {
    title: false,
    DateTimeBegin: false,
    DateTimeEnd: false
  }
  workspace:string = ''
  min:string = ''
  max:string = ''

  getExhibitionEptySearch(){
    this.workspace = localStorage.getItem('workspace') || ''
    let date = ((+ new Date()) / 1000).toFixed(0)
    if(this.workspace == 'personal') {
      this.getCurrentUserExhibitions({
        date: date,
      })
    } else {
      this.getCurrentCompanyExhibitions({
        company: this.workspace,
        date: date,
      })
    }
    this.getCurrentShow
  }

  mounted() {
    this.getExhibitionEptySearch()
  }

  @Watch('title')
  getExhibitions() {
    if(this.title.length > 2) {
      if(this.workspace == 'personal') {
        this.getSearchedUserExhibitions(this.title)
      } else {
        this.getSearchedCompanyExhibitions({
          company: this.workspace,
          search: this.title
        })
      }
    }
    if(this.title.length === 0) {
      this.getExhibitionEptySearch()
    }
  }

  @Watch('fullDialogShow')
  getFullDialogShow() {
    this.DateTimeBegin = ''
    this.DateTimeEnd = ''
    this.title=''
    this.max = ''
    this.min = ''
    this.loading = false
    let date = ((+ new Date()) / 1000).toFixed(0)
    this.getCurrentUserExhibitions({
      date: date,
    })
    this.workspace = localStorage.getItem('workspace') || ''
  }

  get showsFirst() {
    return  this.getCurrentShow.slice(0, this.countShows)
  }

  get showsSecond() {
    return this.getCurrentShow.slice(this.countShows)
  }

  get countShows() {
    return +(this.getCurrentShow.length / 2).toFixed(0) || 1
  }

  getDateBegin(item: any) {
    this.DateTimeBegin = Math.floor(Date.parse(item) / 1000).toString()
    this.min = item.slice(0,10)
  }

  getDateEnd(item: string) {
    this.DateTimeEnd = Math.floor(Date.parse(item) / 1000).toString()
    this.max = item.slice(0,10)
  }

  async tryAddExhibition() {
    this.loading = true
    let flag = false
    if(!this.title) {
      this.isError.title = true
      flag = true
    }
    if(!this.DateTimeBegin) {
      this.isError.DateTimeBegin = true
      flag = true
    }
    if(!this.DateTimeEnd) {
      this.isError.DateTimeEnd = true
      flag = true
    }
    if(flag) {
      this.loading = false
    } else {
      if(this.workspace == 'personal') {
        await this.addUserExhibition({
          title: this.title,
          dateFrom: this.DateTimeBegin,
          dateTo: this.DateTimeEnd
        }).then(() => {
          this.SetFullDialogShow(false)
        })
      } else {
        await this.addCompanyExhibition({
          company: this.workspace,
          params: {
            title: this.title,
            dateFrom: this.DateTimeBegin,
            dateTo: this.DateTimeEnd
          }
        }).then(() => {
          this.loading = false
          this.SetFullDialogShow(false)
        })
      }
      this.SetFullDialogShow(false)
    }
  }

}
